export function formatEUR(price: number, precision?: number): string {
  const isInteger = Number.isInteger(price);

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: isInteger ? 0 : precision,
    maximumFractionDigits: isInteger ? 0 : precision,
  }).format(price);
}

export const numberToLocaleString = (
  num?: number,
  unit?: string,
  precision?: number,
) => {
  return `${num?.toLocaleString('fr-FR', { maximumFractionDigits: precision ?? 2 })} ${unit || ''}`.trim();
};
